import { render, staticRenderFns } from "./userSmtpServersManage.vue?vue&type=template&id=ada41486&scoped=true"
import script from "./userSmtpServersManage.vue?vue&type=script&lang=js"
export * from "./userSmtpServersManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada41486",
  null
  
)

export default component.exports